import queryString from "query-string";

export const addParams = (url: string, params: queryString.ParsedQuery<string | undefined>) => {
  const [baseUrl, query] = url.split("?");
  const parsedParams = queryString.parse(query ?? "");
  const newParams = { ...parsedParams, ...params };
  return `${baseUrl}?${queryString.stringify(newParams)}`;
};
